<style lang="stylus">
    .editor-box
        position absolute
        left 0
        top 36px
        max-width 400px
        width: max-content;
        border-radius 8px
        box-shadow $common-box-shadow
        cursor default
        user-select none
        pointer-events auto
        background-color var(--bg-color-tertiary)
        .editor-topbar
            width auto
            height 32px
            background-color var(--bg-color-tertiary)
            border-top-left-radius 5px
            border-top-right-radius 5px
            .topbar-title
                font-weight: 600;
                float left
                margin-left 16px
                line-height 32px
                color var(--text-color-black)
                width calc(100% - 48px)
                text-overflow ellipsis
                white-space nowrap
                overflow hidden
            .topbar-locked
                float right
                width 16px
                height 16px
                margin 8px
                cursor pointer
                border-radius 3px
                .item-icon,.fix-icon
                    width 16px
                    height 16px
                    color var(--svg-color-gray-42)
                &:hover
                    .item-icon
                        stroke black
                .item-icon
                    stroke #666
        .editor-topbar.active
            background-color var(--bg-color-selected)
            cursor move
</style>

<template>
    <div ref="dragbox" class="editor-box" v-if="showModal">
        <div ref="dragTopbar" class="editor-topbar" :class="{ active: lockBox }">
            <p class="topbar-title">{{ dragTitle }}</p>
            <div ref="fixBtn" class="topbar-locked" v-show="!lockBox" @click="lockedModal()">
                <iconSymbol class="fix-icon" name="lockNail"></iconSymbol>
            </div>
            <div class="topbar-locked" v-if="lockBox" @click="closeModal()">
                <iconSymbol class="item-icon" name="Del"></iconSymbol>
            </div>
        </div>
        <slot></slot>
        <EDNotice v-if="useFixTips" :show="showFixTips" :dom="fixTipsDom" :content="$t('fixTip')" @closeTips="closeFixTips" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import EDNotice from "@/app/components/Notice/EDNotice.vue";

    @Component({
        components: {
            EDNotice,
        },
    })
    export default class NavigationFont extends Vue {
        @Prop()
        dragTitle: string;
        @Prop()
        originPostion: object;
        @Prop()
        showModal: boolean;
        @Prop()
        lockBox: boolean;
        // drag data
        attr: object = { left: 0, top: 0, flag: false };

        // dragbox
        getStyle(dom, attr) {
            return dom.currentStyle ? dom.currentStyle[attr] : getComputedStyle(dom)[attr];
        }
        setAttr(dom) {
            this.attr["left"] = parseInt(this.getStyle(dom, "left")) || 0;
            this.attr["top"] = parseInt(this.getStyle(dom, "top")) || 0;
        }
        returnAttr(dom, x, y) {
            dom.style.left = x + "px";
            dom.style.top = y + "px";
        }
        drag(a, t) {
            a.onmousedown = (e) => {
                this.attr["flag"] = true;
                this.setAttr(t);
                let moveL = null,
                    moveT = null;
                document.onmousemove = (b) => {
                    if (!this.attr["flag"]) {
                        return;
                    }
                    var x = b.clientX - e.clientX;
                    var y = b.clientY - e.clientY;
                    (moveL = x + this.attr["left"]), (moveT = y + this.attr["top"]);
                    this.returnAttr(t, x + this.attr["left"], y + this.attr["top"]);
                    if (b.preventDefault) {
                        b.preventDefault();
                    }
                };
                document.onmouseup = () => {
                    this.$emit("updateBoxPos", {
                        left: moveL,
                        top: moveT,
                    });
                    this.attr["flag"] = false;
                    document.onmouseup = null;
                    document.onmousemove = null;
                };
            };
        }
        lockedModal() {
            // 开启拖拽功能，移除点击空白处关闭
            this.$emit("changeLock", true);
            let dom = this.$refs.dragbox;
            let topbar = this.$refs.dragTopbar;
            this.drag(topbar, dom);
            this.$emit("removeCloseEvent");
        }
        cleanData() {
            let dom = this.$refs.dragbox;
            let topbar = this.$refs.dragTopbar;
            this.$emit("changeLock", false);
            (dom as HTMLElement).style.left = this.originPostion["left"];
            (dom as HTMLElement).style.top = this.originPostion["top"];
            this.attr = { left: 0, top: 0, flag: false };
            (topbar as HTMLElement).onmousedown = null;
        }
        closeModal() {
            // 点击x 还原数据,传递关闭弹窗事件
            this.cleanData();
            this.$emit("closeBox");
        }
        mounted() {
            if (this.lockBox) {
                let dom = this.$refs.dragbox;
                let topbar = this.$refs.dragTopbar;
                this.drag(topbar, dom);
            }
        }
        @Watch("showModal")
        watchShowModal(newv, oldv) {
            if (!this.showModal) {
                this.cleanData();
            } else {
                // 兼容 Navigation.vue  adjustScreen()
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.checkFixTips();
                    });
                }, 100);
            }
        }

        showFixTips = false;
        fixTipsDom = null;
        useFixTips = true;
        checkFixTips() {
            // 检查是否需要弹出提示
            let key = this.dragTitle;
            let checkLocal = () => {
                let showfix = localStorage.getItem("showfixTips") || "";
                let lastfix = localStorage.getItem("lastfixTips") || "";
                if (!!showfix) {
                    return false;
                } else if (lastfix == key) {
                    localStorage.setItem("showfixTips", "1");
                    return true;
                } else if (lastfix != key) {
                    localStorage.setItem("lastfixTips", key);
                    return false;
                }
            };
            if (checkLocal()) {
                let dom = this.$refs.fixBtn as HTMLElement;
                this.fixTipsDom = dom;
                this.showFixTips = true;
            }
        }
        closeFixTips() {
            this.useFixTips = false;
        }
    }
</script>
<i18n>
{
    "zh": {
        "fixTip": "点击图钉按钮可以固定您的菜单。"
    },
    "en": {
        "fixTip": "Click the Pushpin button to fix your menu."
    },
    "fr": {
        "fixTip": "Cliquez sur le bouton Punaise pour corriger votre menu."
    },
    "de": {
        "fixTip": "Klicken Sie auf die Reißzwecke, um Ihr Menü zu korrigieren."
    },
    "jp": {
        "fixTip": "プッシュピンボタンをクリックしてメニューを固定します。"
    },
    "es": {
        "fixTip": "Haz clic en el botón Chincheta para arreglar su menú."
    },
    "pt": {
        "fixTip": "Clique no botão Pushpin para fixar seu menu."
    },
    "it": {
        "fixTip": "Fare clic sul pulsante Puntina da disegno per correggere il menu."
    },
    "tw": {
        "fixTip": "單擊圖釘按鈕可以固定您的菜單。"
    },
    "kr": {
        "fixTip": "메뉴를 수정하려면 버튼을 클릭하세요."
    }
}
</i18n>
